<script>
import tourMixin from '@src/mixins/tour'
import pageMixin from '@src/mixins/pagination'
import productMixin from '@/src/mixins/product'
import { authComputed, merchantComputed } from '@state/helpers'

import lazyLoadComponent from '@router/lazyload-component'

import Layout from '@layouts/main'
import { productStateMap, productTypeList } from '@utils/filter-value-to-text'
export default {
  page: {
    title: '所有項目',
    meta: [{ name: 'description', content: 'Product List' }],
  },

  components: {
    Layout,
    ListItem: () => lazyLoadComponent(import('./components/ListItem')),
    // addProduct: () => lazyLoadComponent(import('./addProduct')),
    BaseButtonDialog: () => import('@components/BaseButtonDialog'),
    BaseButton: () => lazyLoadComponent(import('@components/BaseButton')),
  },
  mixins: [tourMixin, pageMixin, productMixin],
  tourName: 'products',
  data() {
    return {
      addDialogVisible: false,
      dialogCalendarVisible: false,
      filterData: this.initFilterData(),
      stateList: Object.freeze(productStateMap),
      productTypeList: Object.freeze(productTypeList),
      orderByList: Object.freeze([
        {
          label: '依創建時間：近→遠',
          value: 'created_at',
        },
        {
          label: '依最後更新時間：近→遠',
          value: 'updated_at',
        },
      ]),
      productList: [],
      readiedComponents: [],
      modulesLimit: 0,
      modulesUsed: 0,
      currentPage: 1
    }
  },
  watch: {
    currentPage: {
      handler: 'tryToSearchProduct',
      immediate: true,
    },
    readiedComponents: {
      handler: 'componentsReady',
    },
  },
  // inject: ['localPermission'],
  created() {
    this.$store.dispatch('merchant/fetchSingle')
  },
  mounted() {
    if (this.$route.params.showAddDialog === true) this.showAddDialog()
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    merchantCalendarURL() {
      return `${window.location.origin}/api/${this.currentUser.merchantAlias}/${this.currentUser.merchantId}/product/ical`
    },
    showUsageWarning() {
      if (this.modulesLimit === 0) return false
      const percent25 = this.modulesLimit / 4
      const remnant = this.modulesLimit - this.modulesUsed
      return percent25 >= remnant
    },
    isSroresLimit() {
      return this.currentMerchant.plan.stores <= this.productList.length
    },
    filterProducts() {
      let result = JSON.parse(JSON.stringify(this.productList))
      result = this.filterProductInMixin(result)
      if (this.filterData.product.length > 0) {
        result = result.filter(item => item.name && item.name.includes(this.filterData.product))
      }
      if (this.filterData.state.length > 0) {
        result = result.filter(item => item.state.toString() === this.filterData.state)
      }
      return result
    }
  },
  methods: {
    async tryToSearchProduct() {
      const { items, modulesLimit, modulesUsed, total } = await this.$store.dispatch('product/fetchList', Object.assign(this.filterData, this.pageQuery))
      this.productList = items
      this.modulesUsed = modulesUsed
      this.modulesLimit = modulesLimit
      this.$nextTick(() => {
        this.$refs.pagination && this.$refs.pagination.updateTotal(total)
      })
    },
    async tryToFetchList() {
      await this.tryToSearchProduct()
    },
    async handleResetSearch() {
      this.filterData = this.initFilterData()
      await this.tryToSearchProduct()
    },
    initFilterData() {
      return {
        state: '',
        activeOrders: '',
        hidden: '',
        order: 'desc',
        order_by: '',
        phone: '',
        product: '',
        paginate: 0
      }
    },
    updateReadiedComponents(id) {
      this.readiedComponents.push(id)
    },
    componentsReady() {
      if (this.readiedComponents.length === this.productList.length) this.showProductDialog()
    },
    showProductDialog() {
      if (this.$route.params.productId !== undefined) this.$refs[this.$route.params.productId][0].dialogVisible = true
    },
    showAddDialog() {
      this.addDialogVisible = true
    },
    copyCalendarUrl() {
      this.$refs.CalendarUrlInput.select()
      document.execCommand('copy')
      this.$message('連結複製成功')
    },
    openExternal(url) {
      window.open(url, '_blank')
    },
    goToAddProduct() {
      this.$router.push({ name: 'add-product' })
    }
  },
}
</script>

<template>
  <Layout>
    <!-- 最上方 input & 新增button -->
    <div :class="$style.topRegion">
      <el-input :placeholder="'請輸入分店名稱搜尋'" v-model="filterData.product" class="is-border smsInput"
        style="flex-grow: 1;margin-right: 10px;">
        <BaseIcon slot="prefix" name="search" class="el-input__icon" />
      </el-input>
      <div class="btn-top-box right p-0 " :class="$style.TopBtnInput" style="background: transparent">
        <span>
          <el-button v-if="currentMerchant.plan" class="is-round" type="primary" :disabled="isSroresLimit"
            @click="goToAddProduct">
            <BaseIcon name="plus" />
            <span>新增到店</span>
          </el-button>
        </span>
      </div>
    </div>
    <el-alert v-if="showUsageWarning"
      :title="`您目前的項目使用數量： ${modulesUsed} / ${modulesLimit} 。提醒您，項目數量達到上限時，您無法在創建項目，欲擴增項目額度請聯絡業務處理。`" show-icon
      :closable="true" :class="$style.warning"></el-alert>
    <!-- 中間search Bar -->
    <div :class="$style.outerBorder">
      <BaseTableSearch v-slot="{ fields }" hide-action :default-value="filterData" @reset="handleResetSearch"
        @tryToFetchList="tryToFetchList('filter')">
        <el-form-item prop="state">
          <el-select v-model="filterData.state" placeholder="上架狀態">
            <el-option label="所有上架狀態" value></el-option>
            <el-option label="已上架" value="1"></el-option>
            <el-option label="下架中" value="0"></el-option>
          </el-select>
        </el-form-item>
      </BaseTableSearch>
      <!-- 中間各分店資訊 -->
      <div :class="[$style['item__list']]">
        <el-row t type="flex" :gutter="16">
          <el-col v-for="product in filterProducts" :key="product.id" :md="12" :span="24">
            <ListItem :ref="product.id" :data="product" class="mb-3" @updated="tryToSearchProduct"
              @ready="updateReadiedComponents" />
          </el-col>
        </el-row>

      </div>
    </div>
    <BasePagination ref="pagination" :current-page.sync="currentPage" />
    <el-dialog title="全店行事曆" :visible.sync="dialogCalendarVisible" :append-to-body="true" top="0" width="680px">
      <el-input ref="CalendarUrlInput" :value="merchantCalendarURL" :readonly="true">
        <el-button slot="append" @click="copyCalendarUrl">複製此網址</el-button>
      </el-input>
      <p style="margin-top: 50px;">行事曆設定教學</p>
      <div style="margin-bottom: 15px;">
        <el-button style="width: 100%;" type="primary" plain
          @click="openExternal('https://support.apple.com/zh-tw/guide/iphone/iph3d1110d4/ios')">設定於 Apple 行事曆
        </el-button>
      </div>
      <div>
        <el-button style="width: 100%;" type="primary" plain
          @click="openExternal('https://support.google.com/calendar/answer/37100?co=GENIE.Platform%3DDesktop&hl=zh-Hant')">
          設定於 Google 行事曆</el-button>
      </div>
    </el-dialog>
  </Layout>
</template>
<style lang="scss" module>

$column-number: 5;

.outerBorder {
  border: 16px solid $color-body-bg;
  border-top: 0px;
}

.item {
  width: 432px;
  height: 154px;
  margin-bottom: 18px;

  @include max-sm {
    width: calc(100% - 0.5rem);
  }

  &__list {
    padding: 18px 16px;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    background-color: white;

    &--last-2:after {
      width: calc(100% / #{$column-number} * 3 - 15px);
      content: '';
    }

    &--last-3:after {
      width: calc(100% / #{$column-number} * 2 - 15px);
      content: '';
    }

    &--last-4:after {
      width: calc(100% / #{$column-number} * 1 - 15px);
      content: '';
    }
  }
}

.TopBtnInput {
  display: flex;
}

.topRegion {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  padding: 0px 16px;
  align-items: flex-start;
  margin-bottom: 18px;
}

.create {
  border: 2px dashed lightgray;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 45px;
  color: lightgray;
  cursor: pointer;
  margin: 5px 5px 35px 5px;
  height: 190px;
}

.types {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-between;

  &__item {
    min-width: 100px;
    margin-bottom: 20px;
  }
}

.warning {
  background-color: #bf7e45 !important;
  color: white !important;
  margin-top: -20px;
  margin-bottom: 20px;
  padding: 18px 16px;

  :global {
    .el-alert__closebtn {
      color: white !important;
      top: 18px;
      font-size: 18px;
    }
  }
}
</style>
